// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:940px){.teaser__description[data-v-7a96d886]{margin-bottom:50px}.teaser button[data-v-7a96d886]{width:100%}.teaser--collapsed button[data-v-7a96d886]{display:none}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
